import { Trans, useTranslation } from 'react-i18next';
import styles from './ReactionMetric.module.scss';
import { formatSignedPercent, SignedChange } from './SignedChange';

export interface ReactionMetricProps {
  i18nKey: string;
  value: number;
  formattedValue?: string;
}

export const ReactionMetric = ({
  i18nKey,
  value,
  formattedValue,
}: ReactionMetricProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <span className={styles.metric}>
      <Trans
        t={t}
        i18nKey={i18nKey}
        components={[<SignedChange key="key-0" value={value} />]}
        values={{ value: formattedValue ?? formatSignedPercent({ value }) }}
      />
    </span>
  );
};
